import { TRUTHS_REPORT_MODAL_V1_PLAN_ID } from "@/features/subscriptions/report-plan-codes"
import { ReportIds } from "@/features/today/config/reports-data"

import type { AppModalComponentProps } from "../config/modal-registry"
import { ReportPromoModalV1, type ReportPromoCopyV1 } from "./report-promo-modal-v1"

const COPY: ReportPromoCopyV1 = {
  reportId: ReportIds.LoveMatch,
  planId: TRUTHS_REPORT_MODAL_V1_PLAN_ID,
  title: "Unlock Your Love Match",
  description:
    "Reveal hidden signals in your connection, from chemistry and trust to doubts, patterns, and warning signs",
}

export function ReportLoveMatchModalV1(props: AppModalComponentProps) {
  return <ReportPromoModalV1 {...props} copy={COPY} />
}
